/*
 * The three roles an account can hold, and the one rule between them.
 *
 *   worker    an employee: looks for work (staff of a business are employees too)
 *   employer  owns and runs a business that hires
 *   pro       a contractor: offers services. Anyone, in any role, can FIND one.
 *
 * Employee and employer exclude each other; contractor combines with either.
 * Imported by the API (which enforces it) and the app (which hides what the API
 * would refuse), so the two cannot drift.
 */
export const ROLES = ['worker', 'employer', 'pro'] as const
export type Role = (typeof ROLES)[number]

export const clashes = (held: readonly Role[], role: Role): boolean =>
  (role === 'worker' && held.includes('employer')) || (role === 'employer' && held.includes('worker'))
